import { render, staticRenderFns } from "./AddTeamDialog.vue?vue&type=template&id=276b4d1e&scoped=true&"
import script from "./AddTeamDialog.vue?vue&type=script&lang=js&"
export * from "./AddTeamDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "276b4d1e",
  null
  
)

export default component.exports